export default "__VITE_ASSET__adf91ed1__"